import classNames from 'classnames';

import { Button } from 'rsuite';
import styles from './SetupCampaignFooter.module.scss';

export const SetupCampaignFooter = () => {
  return (
    <div>
      <div className={classNames(styles.container)}>
        <Button appearance="ghost" type="button" className={styles.cancel}>
          Cancelar
        </Button>
        <Button appearance="primary" type="submit" className={styles.save}>
          Salvar
        </Button>
      </div>
    </div>
  );
};
